export default __webpack_public_path__ + "static/media/offshore_wind_icon.d947aa7a.svg";